import { render } from "./upload-container.vue?vue&type=template&id=6c0605c3"
const script = {}

import "./upload-container.vue?vue&type=style&index=0&id=6c0605c3&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__